export enum StateTypeEnum {
	Graded = 'graded',
	Submitted = 'submitted',
	InProgress = 'in_progress'
}
